import { defineComponent as _defineComponent } from 'vue'
import OzCloseButton from 'library/v4/components/OzCloseButton.vue'
import OzContainedButton from 'library/v4/components/OzContainedButton.vue'
import OzMultilineInput, { OzMultilineInputBorder } from 'library/v4/components/OzMultilineInput.vue'
import OzIcon from 'library/v4/components/OzIcon.vue'
import OzBox, { OzBoxColors } from 'library/v4/components/OzBox.vue'
import OzPlainButton, { OzPlainButtonColorScheme } from 'library/v4/components/OzPlainButton.vue'
import OzScreenSizeAwareCenterModal from 'library/v4/components/OzScreenSizeAwareCenterModal.vue'
import { storeToRefs } from 'pinia'
import { useWindowSizeStore } from 'pinia/window_size'
import { __ } from '@@/bits/intl'
import { computed, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfacePollBuilder',
  emits: ["close"],
  setup(__props, { emit }: { emit: ({
  (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const { windowHeight, isSmallerThanTabletPortrait } = storeToRefs(useWindowSizeStore())


// TODO: get character limits from backend instead of setting it here
const POLL_CHOICE_CHARACTER_LIMIT = 100
const POLL_CHOICE_VALIDATION_MESSAGE = __('Option cannot exceed %{pollOptionCharLimit} characters', {
  pollOptionCharLimit: POLL_CHOICE_CHARACTER_LIMIT,
})
const POLL_QUESTION_CHARACTER_LIMIT = 500
const POLL_QUESTION_VALIDATION_MESSAGE = __('Description cannot exceed %{pollQuestionCharLimit} characters', {
  pollQuestionCharLimit: POLL_QUESTION_CHARACTER_LIMIT,
})

const pollQuestionValue = ref('')
const pollChoicesData = ref<
  {
    placeholderText: string
    validationMessage: string
    border: OzMultilineInputBorder
    value: string
    required: boolean
  }[]
>([
  {
    placeholderText: __('Choice 1'),
    validationMessage: POLL_CHOICE_VALIDATION_MESSAGE,
    border: 'bottom',
    value: '',
    required: true,
  },
  {
    placeholderText: __('Choice 2'),
    validationMessage: POLL_CHOICE_VALIDATION_MESSAGE,
    border: 'bottom',
    value: '',
    required: true,
  },
  {
    placeholderText: __('Choice 3 (optional)'),
    validationMessage: POLL_CHOICE_VALIDATION_MESSAGE,
    border: 'bottom',
    value: '',
    required: false,
  },
  {
    placeholderText: __('Choice 4 (optional)'),
    validationMessage: POLL_CHOICE_VALIDATION_MESSAGE,
    border: 'none',
    value: '',
    required: false,
  },
])
const anyPollChoiceInputsInvalid = computed(() =>
  pollChoicesData.value.some((pollChoice) => !isInputValid(pollChoice.value, POLL_CHOICE_CHARACTER_LIMIT)),
)

function isPollChoiceDisabled(pollChoiceIndex: number) {
  switch (pollChoiceIndex) {
    case 0: {
      return false
    }
    case 1: {
      return false
    }
    case 2: {
      return isPollChoiceThreeDisabled.value
    }
    case 3: {
      return isPollChoiceFourDisabled.value
    }
    default: {
      return false
    }
  }
}

function isInputValid(input: string, limit: number) {
  return input.length <= limit
}

const isCreateButtonDisabled = computed(
  () =>
    anyPollChoiceInputsInvalid.value ||
    pollChoicesData.value[0].value === '' ||
    pollChoicesData.value[1].value === '' ||
    !isInputValid(pollQuestionValue.value, POLL_QUESTION_CHARACTER_LIMIT) ||
    pollQuestionValue.value === '',
)
const isPollChoiceThreeDisabled = computed(
  () => pollChoicesData.value[0]?.value === '' || pollChoicesData.value[1]?.value === '',
)
const isPollChoiceFourDisabled = computed(
  () =>
    pollChoicesData.value[0]?.value === '' ||
    pollChoicesData.value[1]?.value === '' ||
    pollChoicesData.value[2]?.value === '',
)

const validatedPollChoices = computed(() => {
  return pollChoicesData.value.filter((choice) => {
    return choice.required || choice.value !== ''
  })
})

function handlePollOptionInput(e: InputEvent, pollChoiceIndex: number): void {
  const input = (e.currentTarget as HTMLTextAreaElement).value
  const choice = pollChoicesData.value[pollChoiceIndex]
  choice.value = input
}

function handlePollQuestionInput(e: InputEvent): void {
  const input = (e.currentTarget as HTMLTextAreaElement).value
  pollQuestionValue.value = input
}

return { __sfc: true,windowHeight, isSmallerThanTabletPortrait, emit, POLL_CHOICE_CHARACTER_LIMIT, POLL_CHOICE_VALIDATION_MESSAGE, POLL_QUESTION_CHARACTER_LIMIT, POLL_QUESTION_VALIDATION_MESSAGE, pollQuestionValue, pollChoicesData, anyPollChoiceInputsInvalid, isPollChoiceDisabled, isInputValid, isCreateButtonDisabled, isPollChoiceThreeDisabled, isPollChoiceFourDisabled, validatedPollChoices, handlePollOptionInput, handlePollQuestionInput, OzCloseButton, OzContainedButton, OzMultilineInput, OzIcon, OzBox, OzBoxColors, OzPlainButton, OzPlainButtonColorScheme, OzScreenSizeAwareCenterModal, __ }
}

})